import React, { useState, useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import FloatingNav from "./components/FloatingNav";
import ChatWidget from "./components/ChatBot/ChatWidget";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Skills from "./components/sections/Skills";
import Projects from "./components/sections/Projects";
import Experience from "./components/sections/Experience";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";

export default function Portfolio() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    // Dark is the default; only an explicit prior choice can opt out.
    return savedMode !== null ? JSON.parse(savedMode) : true;
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-bg text-label font-sans antialiased transition-colors duration-200">
        <FloatingNav darkMode={darkMode} setDarkMode={setDarkMode} />
        <ChatWidget />
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Experience />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

